import { render, staticRenderFns } from "./ContractDetailGrid.vue?vue&type=template&id=2161b0e5&scoped=true&"
import script from "./ContractDetailGrid.vue?vue&type=script&lang=js&"
export * from "./ContractDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetailGrid.vue?vue&type=style&index=0&id=2161b0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161b0e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2161b0e5')) {
      api.createRecord('2161b0e5', component.options)
    } else {
      api.reload('2161b0e5', component.options)
    }
    module.hot.accept("./ContractDetailGrid.vue?vue&type=template&id=2161b0e5&scoped=true&", function () {
      api.rerender('2161b0e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/statistics/stats-tab-view/grid/ContractDetailGrid.vue"
export default component.exports